import {useState, useEffect} from "react";
import { isMobile } from "react-device-detect";
import ProgressBar from "./ProgressBar.js";
import { config } from "../config.js";
import services from "../services.js" 

const Search = (props) => {
    
    const [carriers, setCarriers] = useState([])
    const [progress, setProgress] = useState(false)
    const {prefix, setPrefix, serial, setSerial, setData, setNotification, search} = props

    const handlePrefix = (e) =>{
  
        let prefix = e.target.value 
        prefix = (prefix && prefix.toLowerCase() === "prefix") ? "" : prefix
  
        setPrefix(prefix)

        if (prefix && prefix.length === 3) {
            let next_input = document.getElementById("form_serial");
            if (next_input) next_input.focus();
        }
    };

    const handleSerial = (e)=>{
        let serial = e.target.value
        setSerial(serial)
    }

    const onBlurSerial = (e)=>{

        console.log('freeOnB', e.target.value)
        let serial = e.target.value

        if(!serial){
             setSerial("")
        }

        if(serial && serial.length >= 8){

            serial = serial.replace(/\D/g, "")

            if(serial.length === 8){
                setSerial(serial)
            }

            if(serial.length > 8){
                let prefix = serial.slice(0, 3)
                serial = serial.slice(3, 11)
                setPrefix(prefix)
                setSerial(serial)
            } 

        }
    }

    const searchAWB = async() => {

        setNotification(null)
        let messages = []
        let error = false

    
        if(!prefix || prefix === "prefix"){
            error = true
            messages.push("Please select or provide an AWB prefix number.")
        }

        if(!serial){

            error = true
            messages.push("Please provide an AWB serial number.")
        }

        if(error){
            setNotification({
                type : 'warning',
                message : messages,
                notificationTop : true
            })
            return
        }

        if(isNaN(prefix)){
            error = true
            messages.push("AWB prefix must be a number.")
        }

        if(prefix.length !== 3){
            error = true
            messages.push("AWB Prefix must have 3 digits.")
        }

        if(isNaN(serial)){
            error = true 
            messages.push("AWB serial must be a number.")
            
        }

        if(serial.length !== 8){
            error = true
            messages.push("AWB serial must have 8 digits.")
        }

        let params = {
            serial : serial,
            prefix : prefix,
        }

        if(error){

            setNotification({
                type : 'warning',
                message : messages,
                notificationTop : true
            })
            
            return
        }

        setProgress(true)
        let response = await services.get("/tracking/AWB", params)
        setData(response)
        setProgress(false)
        
    }

    useEffect(() => {
      services.get("/tracking/carriers", {})
      .then((response) => {
        
        const carriers_ = response.error ? [] : response.carriers
       
        setCarriers(carriers_)  

        if(response.error){
             setNotification({
                type : 'error',
                message : [response.message ? response.message : ""],
                notificationTop : true
            })
            return 
        }   
      }).catch( (error) => {
        console.log(error)
      })

    },[]);
      

    useEffect(() => {
     
      if(search){
        searchAWB()
      }

    },[search]);

   let carriers_ = carriers ? carriers : []

    carriers_ = carriers_.map((c) => {
        return (
            <option
                key={c.prefix}
                value={c.prefix}
                selected={c.prefix === prefix}
            >
                {c.carrier} - {c.prefix}
            </option>
        );
    });

    return (
        <section style={{ paddingTop : "0.5rem"}}>
            <div className="card secondary">
                <div className={isMobile ? "" : "row side-elements"} >
                    
                    <label  style={{ color : config.majorColor}} > Enter your AWB number </label>
                    
                    <center><ProgressBar show={progress} /></center>
              
                    <div className="columns two">
                    <select
              
                        id="form_prefix" 
                        style={{ fontSize : "1.2rem"}}
                        onChange={handlePrefix} 

                    >
                        <option key={"prefix"} value="prefix" >Prefix</option>
                        {carriers_ ? carriers_ : null}
                    </select>
                    </div>

                    <div className="columns two">
                        <input 
                        type="text" 
                        id="form_prefix1"
                        onChange={handlePrefix} 
                        defaultValue={prefix}
                        maxLength = '3' 
                        placeholder="Prefix" style={{ fontSize : "1.2rem"}}/>

                    </div>

                    <div className="columns three">
                        <input 
                        type="text" 
                        id="form_serial"
                        onChange={handleSerial} 
                        onBlur={onBlurSerial} 
                        defaultValue={serial}
                        maxLength = '14' 
                        placeholder="Serial or AWB" style={{ fontSize : "1.2rem"}}/>

                    </div>

                    <div className= {isMobile ? "columns three" : "columns one"}>
                        <center>
                        <input 
                        disabled={!prefix || !serial}
                        type="submit" 
                        style={{backgroundColor:"#002847"}}   
                        onClick={searchAWB}  
                        value ="Search" 
                    />
                        </center>
                  
                    </div>

                    <div className ="columns five">
                    <p>*Local Date | Time </p>
                    </div>
                </div>
            </div>
        </section>  
    );
};
export default Search;